import { render, staticRenderFns } from "./creditBalance.vue?vue&type=template&id=2207da63&scoped=true"
import script from "./creditBalance.vue?vue&type=script&lang=js"
export * from "./creditBalance.vue?vue&type=script&lang=js"
import style0 from "./creditBalance.vue?vue&type=style&index=0&id=2207da63&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2207da63",
  null
  
)

export default component.exports